module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "home-intro"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-1 hidden-xs"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-xs-12 content"
  }, [_c('h2', [_vm._v("Code & foo_bar Blog")]), _vm._v(" "), _c('p', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#footer'),
      expression: "'#footer'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("by cubeek")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 hidden-xs"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo/beer.png"),
      "alt": "Foobar Beer",
      "title": "Foobar Beer"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57bdfba7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/IntroLarge.vue
// module id = 1833
// module chunks = 1